import React from "react"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import axios from "axios"
import logo from '../images/logo_RT132.png';
import { ReactComponent as Arrow } from "../assets/arrow.svg"
import _ from 'lodash';

import PeopleCard from "../components/people/PeopleCard/PeopleCard"
import Title from "../components/global/Title/Title"
import Content from "../components/global/Content/Content"
import Button from "../components/global/Button/Button"
import Animation from "../components/global/Animation/Animation"

import { Loader } from "../components/common/Loader/Loader"

export default class MembersScreen extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      data: [],
      dataOurPeople: [],
      dataOurPeopleCategory: [],
      loading: false,
      isActive: 0,
      sort: "",
    }
    this.setActiveTab = this.setActiveTab.bind(this )
    this.handleChangeSort =  this.handleChangeSort.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  handleChangeSort(functie) {
    if (functie == null) {
      this.setState({sort: ""});
    } else {
      this.setState({sort: functie});
    }
  }

  setActiveTab(id) {
    this.setState({ isActive: id })
  }

  loadData = () => {
    this.setState({loading: true})
    axios.all([
      axios.get(`/wp-json/wp/v2/pages/113`),
      axios.get(`/wp-json/wp/v2/onze-mensen?per_page=100&?order=desc`),
      axios.get(`/wp-json/wp/v2/onze-mensen-function-category?per_page=100&parent=0`),
    ])
    .then(axios.spread((resData, resDataOurPeople, resDataOurPeopleCategory) => {
      this.setState({
        data: resData.data,
        dataOurPeople: resDataOurPeople.data,
        dataOurPeopleCategory: resDataOurPeopleCategory.data,
        loading: false
      })
    }))
    .catch(error => {
      console.log(error);
    });
  }

  render() {
    const { data, dataOurPeople, dataOurPeopleCategory, loading } = this.state;

    const filteredPeople = dataOurPeople.filter(element => {
      // const filteredPeople = dataOurPeople.filter((element) => element.ourPeopleFunction[0] && element.ourPeopleFunction[0].name === this.state.sort)
      const needle = this.state.sort
      const haystack = element.ourPeopleFunction
      return _.find(haystack, { 'name': this.state.sort })

    })

    return (
      loading === true ? <Loader/> :
      <div>
        <Helmet>
          <title>{data.yoast_title && data.yoast_title}</title>
          <meta name={data.yoast_meta && data.yoast_meta[0].name} content={data.yoast_meta && data.yoast_meta[0].content} />
        </Helmet>
        <section className="relative p-0 pt-16">
          <div className="h-full absolute w-full">
            <Animation/>
          </div>
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
            <div className="ml-1-col w-3/4 py-32">
              <div className="breadcrumb-bar" style={{color: "#F58120"}}>
                <div className="breadcrumb"><Link to="/">Home</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                <div className="breadcrumb" style={{color: "#000"}}>Leden</div>
              </div>
              <Title level="1" className="underlined">{ data.title && data.title.rendered }</Title>
              <Content className="mt-10 xs:w-full w-2/3">{ data.content && data.content.rendered }</Content>
            </div>
            <div className="w-full md:mx-1-col inline-block">
              <div className="buttons md:-mx-1 pb-8">
                <div className="inline-block p-1">
                  <Button
                    isActive={0}
                    className={this.state.isActive === 0 ? 'member-active bg-orange text-white' : 'bg-lightorange'}
                    onClick={() => {
                      this.handleChangeSort(null)
                      this.setActiveTab(0)
                    }}
                    type="filter"
                    value="Alles">Alles
                  </Button>
                </div>
                  { dataOurPeopleCategory && dataOurPeopleCategory.map(prop =>
                    prop.count !== 0 &&
                    <div key={prop.id} className="inline-block p-1">
                      <Button
                        isActive={prop.id}
                        className={this.state.isActive === prop.id ? 'member-active bg-orange text-white' : 'bg-lightorange'}
                        onClick={() => {
                            this.handleChangeSort(prop.name)
                            this.setActiveTab(prop.id)
                        }}
                        type="filter"
                        value={prop.name}>{prop.name}
                      </Button>
                    </div>
                  )}
              </div>
            </div>
            <div className="w-full md:mx-1-col">
              <div className="md:-mx-1">
                {
                  this.state.sort === ""
                  ? dataOurPeople && dataOurPeople.map(prop =>
                    <div key={prop.id} className="w-full widthtest inline-block md:w-6/12 lg:w-4/12 px-2 my-4">
                      <PeopleCard
                        title={prop.title && prop.title.rendered}
                        function={prop.ourPeopleFunction[0] && prop.ourPeopleFunction[0].name}
                        position={prop.acf && prop.acf.professional_position}
                        imageSrc={prop.better_featured_image ? prop.better_featured_image.source_url : logo}
                        />
                    </div>
                  ) : (
                    filteredPeople.map(prop =>
                      <div key={prop.id} className="w-full widthtest inline-block md:w-6/12 lg:w-4/12 px-2 my-4">
                        <PeopleCard
                          title={prop.title && prop.title.rendered}
                          function={prop.ourPeopleFunction[0] && prop.ourPeopleFunction[0].name}
                          position={prop.acf && prop.acf.professional_position}
                          imageSrc={prop.better_featured_image ? prop.better_featured_image.source_url : logo}
                        />
                      </div>
                    )
                  )
                }
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
